import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { computed, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import LoginLayout from '@/pages/login/components/login-layout.vue';
import ProfileForm from './profile-form.vue';
import FormLayout from '@/components/form/form-layout.vue';
import PageLayout from '@/components/page/page-layout.vue';
import HelpLink from '@/components/help-link/help-link.vue';
import { getLoginTheme } from '@/pages/login/login-theme';
import { setSubmitError } from '@/components/ui/validate-form';
import { trlMessage } from '@/services/i18n';
import { UserAPI } from '@/api/user';
import { getUser, updateUser, isRegistered } from '@/utils/user';
import { clearLocalStorage } from '@/utils/local-storage';
import { sendMetrics } from '@/utils/metrics';
import { MetricTags } from '@/utils/tags';
export default /*@__PURE__*/ _defineComponent({
    __name: 'profile',
    setup(__props) {
        const route = useRoute();
        const router = useRouter();
        const userInfo = ref(getUser());
        const loading = ref(false);
        const isOnboarding = computed(() => !isRegistered());
        const theme = computed(() => getLoginTheme(route.query.redirect));
        function logout() {
            updateUser();
            clearLocalStorage();
            const query = typeof route.query.redirect === 'string' ? { redirect: route.query.redirect } : {};
            router.push({ name: 'login', query });
        }
        function onSubmit(user, context) {
            if (loading.value) {
                return;
            }
            loading.value = true;
            UserAPI.updateUserInfo(user)
                .then((resp) => {
                const wasOnboarding = isOnboarding.value;
                userInfo.value = resp;
                if (wasOnboarding) {
                    sendMetrics(MetricTags.registr);
                }
                updateUser(resp);
                const redirect = route.query.redirect;
                if (typeof redirect === 'string') {
                    router.push(redirect);
                }
                else if (wasOnboarding) {
                    router.push({ name: 'orders' });
                }
            })
                .catch((error) => {
                setSubmitError(error, {
                    setError: context.setError,
                    focusInvalidField: context.focusInvalidField
                });
            })
                .finally(() => {
                loading.value = false;
            });
        }
        return (_ctx, _cache) => {
            return (isOnboarding.value)
                ? (_openBlock(), _createBlock(LoginLayout, {
                    key: 0,
                    theme: theme.value,
                    "show-support": false
                }, {
                    "header-action": _withCtx(() => [
                        _createElementVNode("button", {
                            type: "button",
                            class: _normalizeClass(_ctx.$style.logout),
                            onClick: logout
                        }, _toDisplayString(_unref(trlMessage)('button.logout')), 3)
                    ]),
                    default: _withCtx(() => [
                        _createElementVNode("h1", {
                            class: _normalizeClass(_ctx.$style.registrationTitle)
                        }, _toDisplayString(theme.value.registrationTitle), 3),
                        _createVNode(ProfileForm, {
                            "default-values": userInfo.value,
                            loading: loading.value,
                            "submit-label": _unref(trlMessage)('button.go.to.tickets'),
                            onSubmit: onSubmit
                        }, null, 8, ["default-values", "loading", "submit-label"])
                    ]),
                    _: 1
                }, 8, ["theme"]))
                : (_openBlock(), _createBlock(PageLayout, { key: 1 }, {
                    default: _withCtx(() => [
                        _createVNode(FormLayout, {
                            title: _unref(trlMessage)('page.profile'),
                            "title-level": 2
                        }, {
                            default: _withCtx(() => [
                                _createVNode(ProfileForm, {
                                    "default-values": userInfo.value,
                                    loading: loading.value,
                                    "submit-label": _unref(trlMessage)('button.save'),
                                    onSubmit: onSubmit
                                }, null, 8, ["default-values", "loading", "submit-label"]),
                                _createElementVNode("div", {
                                    class: _normalizeClass(_ctx.$style.help)
                                }, [
                                    _createVNode(HelpLink)
                                ], 2)
                            ]),
                            _: 1
                        }, 8, ["title"])
                    ]),
                    _: 1
                }));
        };
    }
});
